import * as React from "react";
import * as LabelPrimitive from "@radix-ui/react-label";
import {cn} from "./utils";
import "./ui.css";
import "./Label.module.css";

const Label = React.forwardRef(({className, ...props}, ref) => {
    return <LabelPrimitive.Root ref={ref} data-slot="label" className={cn("ui-label", className)} {...props} />;
});

Label.displayName = "Label";

export {Label};
